var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("picture", [
    _vm.dto.xxlSrcSet
      ? _c("source", {
          attrs: { media: "(min-width: 1440px)", srcset: _vm.dto.xxlSrcSet },
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.dto.xlSrcSet
      ? _c("source", {
          attrs: { media: "(min-width: 1200px)", srcset: _vm.dto.xlSrcSet },
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.dto.largeSrcSet
      ? _c("source", {
          attrs: { media: "(min-width: 960px)", srcset: _vm.dto.largeSrcSet },
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.dto.mediumSrcSet
      ? _c("source", {
          attrs: { media: "(min-width: 736px)", srcset: _vm.dto.mediumSrcSet },
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.dto.smallSrcSet
      ? _c("source", {
          attrs: { media: "(min-width: 480px)", srcset: _vm.dto.smallSrcSet },
        })
      : _vm._e(),
    _vm._v(" "),
    _c("img", {
      class: _vm.cssClasses,
      attrs: {
        loading: "lazy",
        alt: _vm.dto.alt,
        srcset: _vm.dto.xsSrcSet,
        src: _vm.dto.src,
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }